import { FC, ReactNode, createContext, memo, useContext, useEffect, useState } from 'react';

import * as Style from '../../styles/context/styles.loader';

export type LoaderScreenContextProps = {
    toggleLoader: ({ show }: {show: boolean}) => void;
    showLoader: boolean;
};

const LoaderScreenContext = createContext({} as LoaderScreenContextProps);

const LoaderScreenProvider: FC<{children: ReactNode}> = memo(({ children }) => {
  const [showLoader, setShowLoader] = useState(true);
  const [shouldRender, setShouldRender] = useState(true);

  const toggleLoader = ({ show }: {show: boolean}) => setShowLoader(show);

  const values: LoaderScreenContextProps = { toggleLoader, showLoader };

  useEffect(() => {
    setTimeout(() => {
      setShouldRender(showLoader);
    }, 480);
  }, [showLoader]);

  /**
   * Renders the LoaderScreenProvider component.
   * @returns The JSX for the LoaderScreenProvider, including the loading screen and the children components.
  */
  return(
    <LoaderScreenContext.Provider value={values}>
      <Style.StyledWrapperLoader $isVisible={showLoader} $shouldRender={shouldRender} >
        <Style.StyledContentLoader $isVisible={showLoader} >
          <Style.SpinnerWrapper>
            <Style.Spinner viewBox="0 0 50 50">
              <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"/>
            </Style.Spinner>
          </Style.SpinnerWrapper>
        </Style.StyledContentLoader>
      </Style.StyledWrapperLoader>
      {children}
    </LoaderScreenContext.Provider>
  );

});

LoaderScreenProvider.displayName = 'LoaderScreenProvider';
export const useLoaderScreenContext = (): LoaderScreenContextProps => useContext(LoaderScreenContext);

export { LoaderScreenContext, LoaderScreenProvider };
